export default {
  // Checklist
  tasksBadge: '{done}/{total} tasks',
  taskTitle: 'Task title',
  taskTitlePlaceholder: 'e.g. Set up exclusion zone',
  taskDetails: 'Task details',
  taskDetailsPlaceholder: 'Details for the crew (optional)',
  saveTask: 'Save task',
  addTask: 'Add task',
  photoBy: 'Photo by {name}, {when}',
  photoByCaption: 'Photo by {name}, {when}: {caption}',
  removePhotoBy: 'Remove photo by {name}',
  doneBy: 'Done by {name}',
  theCrew: 'the crew',
  checklist: 'Checklist',
  checklistHint: 'Tasks the crew tick off from the app.',
  checklistHintNew: 'Optional. Tasks the crew tick off from the app once the job is published.',
  editTask: 'Edit task {title}',
  removeTask: 'Remove task {title}',

  // Repeat weekly
  repeatWeekly: 'Repeat weekly',
  until: 'Until',
  untilHint: 'One draft per chosen day from the start date, each at the same time of day at the site.',
  crewEveryOccurrence: 'Crew on every occurrence',
  crewEveryOccurrenceCount: 'Crew on every occurrence ({count})',
  searchCrew: 'Search crew',
  repeatCrewHint: 'Optional. Anyone already booked on another job at that time is left off that day.',

  // Job dialog
  editJob: 'Edit job',
  newJob: 'New job',
  jobUpdated: 'Job updated',
  jobCreatedDraft: 'Job created as a draft',
  createdDraftsOne: 'Created {count} draft job',
  createdDraftsOther: 'Created {count} draft jobs',
  createdDraftsSkipped: "{created}, but some crew couldn't be added: {details}.",
  draftTasksFailedOne: "Draft created, but {count} task couldn't be added. Edit the job to add them.",
  draftTasksFailedOther: "Draft created, but {count} tasks couldn't be added. Edit the job to add them.",
  newJobDescription: 'Created as a draft. Nobody is notified until you publish it.',
  title: 'Title',
  titlePlaceholder: 'e.g. Level 2 slab pour',
  site: 'Site',
  selectSite: 'Select a site',
  jobType: 'Job type',
  jobTypeNone: 'No job type',
  jobTypeHint: 'Reminder profiles can be limited to some job types. Manage them in Settings.',
  startDate: 'Start date',
  startTime: 'Start time',
  endDate: 'End date',
  endTime: 'End time',
  siteLocalTime: "Times are the site's local time ({zone}).",
  notesHint: 'Optional. Visible to assigned employees.',
  mustAccept: 'Employees must accept this job',
  fixedOncePublished: 'Fixed once published.',
  acceptHint: 'Employees can accept, or decline with a reason.',
  mandatoryHint: 'Mandatory: employees are assigned automatically and cannot decline.',
  openSpots: 'Open spots',
  openSpotsHintPublished: 'Employees can claim these from the app now. You approve each claim, which adds them to the crew and fills a spot.',
  openSpotsHintRepeats: 'Optional. Every repeat gets this many spots employees can claim from the app once it is published. You approve each claim.',
  openSpotsHintNew: 'Optional. Spots employees can claim from the app once the job is published, on top of anyone you assign. You approve each claim.',
  liveTracking: 'Track crew position on the site map while working this job',
  liveTrackingHint: "Links position pings to this job. Only employees who have live tracking switched on are tracked, and only while they're confirmed onsite.",
  sickContacts: 'Sick leave contacts',
  sickContactsHint: "Optional. Emailed when anyone on this job requests sick leave, as well as whoever the company's sick leave settings tell. Up to {max} employees with an email address.",
  sickContactsOnly: "Only tell these people (ignore the company's sick-leave settings for this job)",
  cancelJustThis: 'Cancel just this one',
  cancelJob: 'Cancel job',
  cancelThisAndFuture: 'Cancel this + future',
  createDrafts: 'Create drafts',
  createDraft: 'Create draft',
  cancelJobTitle: 'Cancel this job?',
  cancelJobPublished: 'Everyone assigned will be notified that the job is cancelled.',
  cancelJobDraft: 'This draft will be removed from the board.',
  jobCancelled: 'Job cancelled',
  cancelSeriesTitle: 'Cancel this and later jobs?',
  cancelSeriesMessage: 'This job and every later one in its repeating series will be cancelled. Crew on any that are published will be notified.',
  cancelSeriesConfirm: 'Cancel this and future jobs',
  cancelledJobsOne: 'Cancelled {count} job',
  cancelledJobsOther: 'Cancelled {count} jobs',

  // Open spot claims
  conflictJobOverlap: 'Now booked on another job then',
  conflictShiftOverlap: 'Now has a shift then',
  conflictOnLeave: 'On approved leave then',
  conflictUnavailable: "Said they can't work then",
  openBadge: '{count} open',
  rejectClaim: 'Reject claim',
  rejectClaimDescription: "{name} will be told their claim wasn't approved.",
  rejectedClaim: "Rejected {name}'s claim",
  reason: 'Reason',
  reasonHint: 'Optional. Shown to them in the app.',
  reject: 'Reject',
  approve: 'Approve',
  approveName: 'Approve {name}',
  rejectName: 'Reject {name}',
  claimedOpenSpot: '<name>{name}</name> claimed an open spot · {when}',
  addedToCrew: '{name} added to the crew',

  // lib/jobs
  taskDoneOne: '1 task done',
  allTasksDone: 'All {total} tasks done',
  tasksDoneOf: '{done} of {total} tasks done',

  // lib/openSpots
  crewNotifiedOne: '{count} employee notified',
  crewNotifiedOther: '{count} employees notified',
  spotsPostedOne: '{count} open spot posted to the app',
  spotsPostedOther: '{count} open spots posted to the app',
  publishedWith: 'Published. {details}',
  jobPublished: 'Job published',
}
